import { AwsCredentialIdentity } from '@aws-sdk/types';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Proveedor de credenciales para `S3Client`: credenciales temporales del
 * Identity Pool de Cognito (rol auth si hay sesión, rol guest si no).
 * El SDK lo vuelve a invocar cuando `expiration` vence.
 */
export async function amplifyS3Credentials(): Promise<AwsCredentialIdentity> {
    const { credentials } = await fetchAuthSession();
    if (!credentials) {
        throw new Error(
            'No hay credenciales AWS de Cognito disponibles para S3.'
        );
    }
    return credentials;
}
